import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Subject } from 'rxjs';
import { TicketService } from './Ticket.service';
import { ContactService } from './Contact.service';
import { ChatService } from './Chat.service';
import { PushNotificationsService } from './Notifycation.service';
import { ToastrService } from 'ngx-toastr';
import * as Sentry from '@sentry/browser';
import { Severity } from '@sentry/browser';
import { SocketActionEnum } from '../enums/socket-notify-type.enum';
import { ChatListener } from '../../pages/admin/icontact/chat/chat.listener';
import { Router } from '@angular/router';
import { isMongoDBObjectId } from '../utils/common';

declare const WebPush: any;

@Injectable()
export class SocketService {
  public no_image = 'assets/images/contact.png';
  public no_image_mail = 'assets/images/mailbox.jpg';

  public user: any = null;
  public username: any = null;
  public agentId: any = null;
  public socket: any;
  public ringAudio = new Audio('assets/sounds/incoming.mp3');
  public endCallAudio = new Audio('assets/sounds/beep_volume_down2.wav');
  public isCallout = false;
  public isAnswered = false;
  public call_id: any;
  public ticket_id: any;
  // Observable string sources
  private missionAnnouncedSource = new Subject<any>();
  // Observable string streams
  missionAnnounced$ = this.missionAnnouncedSource.asObservable();
  private socketSource = new Subject<string>();
  socket$ = this.socketSource.asObservable();
  private is_finish = true;

  constructor(
    private ticketService: TicketService,
    private contactService: ContactService,
    private chatService: ChatService,
    private toastr: ToastrService,
    private router: Router,
    private chatListener: ChatListener,
    private pushNotification: PushNotificationsService
  ) {
    this.initData();
    this.ringAudio.addEventListener(
      'ended',
      function () {
        this.currentTime = 0;
        this.play();
      },
      false
    );
  }
  removeRing() {
    this.ringAudio.pause();
    this.ringAudio.currentTime = 0;
  }
  // Service message commands
  announceMission(mission: string) {
    this.missionAnnouncedSource.next(mission);
  }

  initData() {
    this.user = JSON.parse(localStorage.getItem('User'));
    this.username = localStorage.getItem('username');
    this.agentId = localStorage.getItem('agentId');
  }

  updateChatNotify(data) {
    this.missionAnnouncedSource.next({
      action: 'updateNotify',
      data: data,
    });
  }

  updateChatData(data) {
    this.missionAnnouncedSource.next({
      action: 'updateChatData',
      data: data,
    });
  }

  reloadLastestTicket() {
    this.missionAnnouncedSource.next({
      action: 'reloadLastestTicket',
      data: {},
    });
  }

  opentab(data: any, type: string, action: string) {
    this.missionAnnouncedSource.next({
      action: 'open-tab',
      data: {
        type: type,
        action: action,
        detail: data,
      },
    });
  }

  editTab(tabIndex: any, action: string) {
    this.missionAnnouncedSource.next({
      action: 'edit-tab',
      data: {
        tabIndex: tabIndex,
        action: action,
      },
    });
  }

  newHandTicket() {
    this.missionAnnouncedSource.next({
      action: 'newHandTicket',
      data: {},
    });
  }

  updateHandTicket(data) {
    data.action = 'hand';
    this.missionAnnouncedSource.next({
      action: 'updateHandTicket',
      data: data,
    });
  }

  setSocket(socket: any) {
    this.socket = socket;
    this.socketSource.next(socket);
  }

  updateMonitor(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor',
      data: data,
    });
  }

  newEmail(data) {
    this.pushNotification.generateNotification([
      {
        title: data.emailFrom,
        content: data.emailSubject ? data.emailSubject : data.title, // 'Thư mới từ ' + data.emailFrom,
        icon: this.no_image_mail,
      },
    ]);
    this.missionAnnouncedSource.next({
      action: 'new-email',
      data: data,
    });
  }

  newNotification(data) {
    console.log(data);
    if (
      data.type == SocketActionEnum.ZALO ||
      data.type == SocketActionEnum.FACEBOOK ||
      data.type == SocketActionEnum.CHAT
    ) {
      this.chatListener.updateOfflineChannel();
      this.toastr
        .info(data.title, 'Thông báo', {
          timeOut: 5000,
          positionClass: 'toast-bottom-right',
        })
        .onTap.subscribe(() => {
          this.chatListener.openChat({
            data: {},
            channel: 'offline',
          });
        });
    } else {
      this.toastr.info(data.title, 'Thông báo', {
        timeOut: 5000,
        positionClass: 'toast-bottom-right',
      });
      this.pushNotification.generateNotification([
        {
          title: 'Thông báo',
          content: data.title,
          icon: data.type == 'email' ? this.no_image_mail : this.no_image,
        },
      ]);
    }
  }

  showAvailableAgent(data) {
    this.missionAnnouncedSource.next({
      action: 'available-agent',
      data: data,
    });
  }

  updateMonitorAgent(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-agent',
      data: data,
    });
  }

  updateMonitorAgentDashboard(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-agent-dashboard',
      data: data,
    });
  }

  updateMonitorAllAgent(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-all-agent',
      data: data,
    });
  }

  updateMonitorCall(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-call',
      data: data,
    });
  }

  updateMonitorCallList(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-calllist',
      data: data,
    });
  }
  updateMonitorAgentPhoneType(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-agent-phone-type',
      data: data,
    });
  }

  updateMonitorCallDetail(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-calldetail',
      data: data,
    });
  }

  updateMonitorCallDetailEnd(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-calldetail-end',
      data: data,
    });
  }

  ring(username, data, visibility = true) {
    localStorage.setItem('caller', data.caller);
    if (
      (data.callType == 'CALL_INBOUND' || (data.callType == 'CALL_OUTBOUND' && isMongoDBObjectId(data.campaignId))) &&
      !data.callId.includes('PRG')
    ) {
      this.ringAudio.play();
      if (!visibility) {
        this.newNotification({ type: 'CALL', title: 'Cuộc gọi mới' });
      }
    }
    this.isCallout = false;
    if (data.spy) {
      return;
    }
    if (data.username == username && this.is_finish) {
      this.is_finish = false; // ngăn không cho cuộc gọi nữa đến
      this.ticket_id = data.ticketId;
      this.call_id = data.callId;
      if (data.ticketId) {
        this.ticketService
          .find(data.ticketId)
          .toPromise()
          .then(res => {
            if (res.status == 200 && !res.error && res.data) {
              this.contactService.findInAll({ _id: res.data.requester_id }).subscribe(rs => {
                if (rs.status == 200 && !rs.error) {
                  res.data['request'] = rs.data;
                  const requeseter = rs.data.name ? rs.data.name : rs.data.phone ? rs.data.phone : rs.data.email;
                  res.data.subject =
                    data.callType == 'CALL_INBOUND'
                      ? 'Cuộc gọi từ ' + requeseter
                      : 'Cuộc gọi ra cho khách ' + requeseter;
                  res.data._id = data.ticketId;
                  res.data.call_id = data.callId;
                  Sentry.captureMessage('CALL_ACTION: open exists ticket from:' + data.caller, Sentry.Severity.Log);
                  this.opentab(res.data, 'ticket', 'ring');
                }
              });
            }
          });
      } else {
        this.ticketService
          .findByCall(data.callId)
          .toPromise()
          .then(res => {
            if (res.status == 200 && !res.error && res.data) {
              this.contactService.findInAll({ _id: res.data.requester_id }).subscribe(rs => {
                if (rs.status == 200 && !rs.error) {
                  res.data['request'] = rs.data;
                  const requeseter = rs.data.name ? rs.data.name : rs.data.phone ? rs.data.phone : rs.data.email;
                  res.data.subject =
                    data.callType == 'CALL_INBOUND'
                      ? 'Cuộc gọi từ ' + requeseter
                      : 'Cuộc gọi ra cho khách ' + requeseter;
                  res.data.call_id = data.callId;
                  Sentry.captureMessage('CALL_ACTION: open exists ticket from:' + data.caller, Sentry.Severity.Log);
                  this.opentab(res.data, 'ticket', 'ring');
                }
              });
            } else {
              const phone = data.caller;
              this.contactService.findByPhone(phone).subscribe(res => {
                if (res.status == 200 && !res.error && res.data) {
                  const requeseter = res.data.name ? res.data.name : res.data.phone ? res.data.phone : res.data.email;
                  // da ton tai contact
                  const payload = {
                    requester_id: res.data._id,
                    source: 'call',
                    source_detail: data.callType,
                    call_id: data.callId,
                    call_type: data.callType,
                    status: 1,
                    subject:
                      data.callType == 'CALL_INBOUND'
                        ? 'Cuộc gọi từ ' + requeseter
                        : 'Cuộc gọi ra cho khách ' + requeseter,
                    created_at: new Date(),
                  };
                  Sentry.captureMessage('CALL_ACTION: create ticket for:' + data.caller, Sentry.Severity.Log);
                  this.ticketService.create(payload).subscribe(rs => {
                    rs.data.request = res.data;
                    res.data.call_id = data.callId;
                    this.opentab(rs.data, 'ticket', 'ring');
                  });
                } else {
                  // chua ton tai contact co so phone nay
                  const payloadContact = {
                    phone: phone,
                    name: phone,
                    source: data.callType,
                    created_at: new Date(),
                    role: 'end_user',
                  };
                  Sentry.captureMessage('CALL_ACTION: create customer for:' + data.caller, Sentry.Severity.Log);
                  this.contactService.create(payloadContact).subscribe(res => {
                    if (res.status == 200 && !res.error && res.data) {
                      const payload = {
                        requester_id: res.data._id,
                        source: 'call',
                        source_detail: data.callType,
                        call_id: data.callId,
                        call_type: data.callType,
                        status: 1,
                        subject:
                          data.callType == 'CALL_INBOUND' ? 'Cuộc gọi từ ' + phone : 'Cuộc gọi ra cho khách ' + phone,
                        created_at: new Date(),
                      };
                      Sentry.captureMessage('CALL_ACTION: create ticket for:' + data.caller, Sentry.Severity.Log);
                      this.ticketService.create(payload).subscribe(rs => {
                        rs.data.request = res.data;
                        res.data.call_id = data.callId;
                        this.opentab(rs.data, 'ticket', 'ring');
                      });
                    }
                  });
                }
              });
            }
          });
      }
    }
  }

  execMsg(username, code, data, isVoiceActivated, visibility = true) {
    switch (code) {
      case environment.code.CALL_ACTION_RESPONSE_ID: {
        if (data.status == 'OK') {
          this.toastr.info('', 'Gửi yêu cầu thành công', {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          });
        } else if (data.status == 'INCALL') {
          this.toastr.error('', 'Không thể thực hiện khi đang trong cuộc gọi', {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          });
        } else if (data.status == 'NOTFOUND' || data.status == 'IPCCERR0002') {
          this.toastr.error('', 'Không tìm thấy Agent', {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          });
        } else if (data.status == 'IPCCERR0001') {
          this.toastr.error('', 'Agent bận', {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          });
        } else if (data.status == 'IPCCERR0000') {
          this.toastr.error('', 'Không tìm thấy cuộc gọi', {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          });
        } else {
          this.toastr.error('', 'Gửi yêu cầu thất bại', {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          });
        }
        break;
      }
      case environment.code.OUT_CALL_RESPONSE_ID: {
        this.isCallout = true;
        if (data.errorCode == 'OK') {
          if (isVoiceActivated) {
            if (
              data.callId.includes('HAPPYCALL') ||
              data.callId.includes('ZALO') ||
              (data.ticketId && data.ticketId != null && data.ticketId != '')
            ) {
              this.ring(username, data, visibility);
              this.missionAnnouncedSource.next({
                action: 'ring',
                data: data,
              });
            }
          }
        }
        break;
      }
      case environment.code.RING_AGENT_RESPOND_ID: {
        // cuộc gọi đến
        if (!isVoiceActivated) {
          break;
        }
        if (username == data.username) {
          this.ring(username, data, visibility);
          this.missionAnnouncedSource.next({
            action: 'ring',
            data: data,
          });
        }
        // this.updateMonitor({
        //   event:'call_ringing',
        //   id: data.callId,
        //   tenant_id: this.user.tenant_id
        // })
        break;
      }

      case environment.code.NEW_NOTIFICATION_ID: {
        if ('agent_reject' == data.type || 'phone_failed' == data.type) {
          if (!isVoiceActivated) {
            break;
          }
          this.toastr.error(data.title, 'Thông báo', {
            timeOut: 15000,
            positionClass: 'toast-bottom-right',
          });
        } else {
          this.newNotification(data);
        }
        break;
      }

      case environment.code.OUTCALL_ERROR_RESPONSE_ID: {
        this.removeRing();
        if (!isVoiceActivated) {
          this.toastr.error('', 'Vui lòng kích hoạt thoại để thực hiện gọi ra', {
            timeOut: 5000,
            positionClass: 'toast-bottom-right',
          });
          break;
        }
        let errMessage = '';
        let type = 'error';
        switch (data.errorCode) {
          case 401:
          case '401':
            errMessage = 'Lỗi 401: không thể gọi ra, do đầu số/IP tổng đài của khách hàng chưa đăng ký với Hub!';
            break;
          case 402:
          case '402':
            errMessage = 'Lỗi 402: hết hạn mức cước!';
            break;
          case 403:
          case '403':
            errMessage = 'Lỗi 403: hub không chấp nhận cuộc gọi do chưa khai ip hoặc lý do khác!';
            break;
          case 404:
          case '404':
            errMessage = 'Lỗi 404: không có routing rule nào trên Hub, hoặc không còn số để gọi ra!';
            break;
          case 408:
          case '408':
            errMessage = 'Lỗi 408: không có phản hồi!';
            break;
          case 420:
          case '420':
            errMessage = 'Lỗi 420: thuê bao không đúng định dạng 09xx (10 chữ số) và 02xxx (11 hoặc 12 chữ số)!';
            break;
          case 430:
          case '430':
            errMessage = 'Lỗi 430: cuộc gọi được chuyển hướng voicemail!';
            type = 'info';
            break;
          case 480:
          case '480':
            errMessage = 'Lỗi 480: thuê bao không liên lạc được!';
            break;
          case 485:
          case '485':
            errMessage = 'Lỗi 485: thuê bao không tồn tại!';
            break;
          case 486:
          case '486':
            errMessage = 'Lỗi 486: người nhận từ chối trả lời cuộc gọi!';
            break;
          case 487:
          case '487':
            errMessage = 'Lỗi 487: cuộc gọi bị ngắt!';
            break;
          case 488:
          case '488':
            errMessage = 'Lỗi 488: thuê bao bận!';
            break;
          case 500:
          case '500':
            errMessage = 'Lỗi 500: hệ thống Hub tổng đài gặp sự cố, vui lòng thử lại sau!';
            break;
          case 503:
          case '503':
            errMessage = 'Lỗi 503: kết nối đến thống Hub tổng đài gặp sự cố, vui lòng thử lại sau!';
            break;
          case 603:
          case '603':
            errMessage = 'Lỗi 603: đầu số đã bị khóa bởi mạng của người nhận!';
            break;
          case 607:
          case '607':
            errMessage = 'Lỗi 607: khách hàng đăng ký không nhận cuộc gọi này!';
            break;
          case 608:
          case '608':
            errMessage = 'Lỗi 608: hệ thống đang quá tải, vui lòng thử lại sau!';
            break;
        }
        if (errMessage && type === 'error') {
          this.toastr.error('', errMessage, {
            timeOut: 5000,
            positionClass: 'toast-bottom-right',
          });
        }
        if (errMessage && type === 'info') {
          this.toastr.info('', errMessage, {
            timeOut: 5000,
            positionClass: 'toast-bottom-right',
          });
        }
        data['finisher'] = 'agent';
        this.endCall(username, data);
        break;
      }

      case environment.code.USER_END_CALL_RESPOND_ID: {
        this.removeRing();
        if (!isVoiceActivated) {
          break;
        }
        data['finisher'] = 'user';
        this.endCall(username, data);
        break;
      }

      case environment.code.AGENT_END_CALL_RESPOND_ID: {
        this.removeRing();
        if (!isVoiceActivated) {
          break;
        }
        data['finisher'] = 'agent';
        Sentry.captureMessage(
          'CALL_ACTION: uaid:' + this.user.agent_id + ' answerCall: ' + data.caller,
          Sentry.Severity.Log
        );
        // this.endCall(username, data)
        if (this.isAnswered) {
          this.endCall(username, data);
        } else {
          const ticketCallId = document.getElementById('ticketCallId').innerHTML;
          if (data.callId == ticketCallId) {
            this.endCall(username, data);
          } else {
            console.log('agentendcall set timeout ' + data.callId);
            setTimeout(() => {
              this.endCall(username, data);
            }, 4500);
          }
        }
        this.isAnswered = false;
        break;
      }

      case environment.code.DIVERT_STOP_RESPONSE: {
        this.removeRing();
        if (!isVoiceActivated) {
          break;
        }
        // co answer neu stop thi tat
        // ko co anser ma shop thi hien thong bao chuyen ko thanh con
        data['finisher'] = 'agent';
        this.endCall(username, data);
        break;
      }
      case environment.code.END_CALL_RESPOND_ID: {
        if (!isVoiceActivated) {
          break;
        }
        // kết  thúc cuộc gọi
        this.endCall(username, data);
        break;
      }

      case environment.code.AGENT_ANSWER_RESPOND_ID: {
        this.removeRing();
        if (!isVoiceActivated) {
          break;
        }
        this.isAnswered = true;
        const ticketCallId = document.getElementById('ticketCallId').innerHTML;
        if (data.callId == ticketCallId) {
          this.answer(username, data);
        } else {
          console.log('agent answer set timeout ' + data.callId);
          setTimeout(() => {
            this.answer(username, data);
          }, 4500);
        }
        break;
      }

      case environment.code.HOLD_RESPOND_ID: {
        if (!isVoiceActivated) {
          break;
        }
        this.hold(username, data);
        break;
      }

      case environment.code.UNHOLD_RESPOND_ID: {
        if (!isVoiceActivated) {
          break;
        }
        this.unHold(username, data);
        break;
      }

      case environment.code.PERFORMING_CALL_ACTION_RESPONSE_ID: {
        if (!isVoiceActivated) {
          break;
        }
        this.callOutResponseAction(username, data);
        break;
      }

      case environment.code.MUTE_RESPOND_ID: {
        if (!isVoiceActivated) {
          break;
        }
        this.mute(username, data);
        break;
      }
      case environment.code.UNMUTE_RESPOND_ID: {
        if (!isVoiceActivated) {
          break;
        }
        this.unMute(username, data);
        break;
      }

      case environment.code.NEW_EMAIL_RESPOND_ID: {
        this.newEmail(data);
        break;
      }
      case environment.code.SEARCH_AGENT_RESPONSE_ID: {
        this.showAvailableAgent(data);
        break;
      }
      case environment.code.SUPVERVISOR_AGENT_RESPONSE_ID: {
        this.updateMonitorAgentDashboard(data);
        break;
      }
      case environment.code.CHANGE_AGENT_STATUS_REQUEST: {
        this.updateMonitorAgent(data);
        break;
      }
      case environment.code.GET_DETAIL_AGENT_IN_QUEUE_REQUEST: {
        this.updateMonitorAllAgent(data);
        break;
      }
      case environment.code.SUPVERVISOR_CALL_RESPONSE_ID: {
        this.updateMonitorCall(data);
        break;
      }

      // monitor call
      case environment.code.CALL_DETAIL_RESPONSE_ID: {
        if (data.ended == false) {
          this.updateMonitorCallDetail(data.data);
        } else {
          this.updateMonitorCallDetailEnd(data.callId);
        }
        break;
      }
      case environment.code.CALL_LIST_RESPONSE_ID: {
        this.updateMonitorCallList(data.data);
        break;
      }
      case environment.code.VOICE_ACTIVATED: {
        this.updateMonitorAgentPhoneType(data.data);
        break;
      }
      default:
        break;
    }
  }

  monitor(event, id, caller?: any): void {
    const user = JSON.parse(localStorage.getItem('User'));
    const payload = {
      event: event,
      id: id,
      tenant_id: user.tenant_id,
    };
    if (caller) {
      payload['caller'] = caller;
    }
    this.chatService.monitor(payload);
  }

  loadAgentMonitor() {
    const data = this.standParam({});
    const payload = {
      data: data,
    };

    payload['objectId'] = environment.code.GET_DETAIL_AGENT_IN_QUEUE_REQUEST;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  loadCallMonitor() {
    if (!this.socket) {
      this.socketSource.subscribe(() => {
        const data = this.standParam({});
        const payload = {
          data: data,
        };

        payload['objectId'] = environment.code.SUPVERVISOR_CALL_RESPONSE_ID;
        if (!this.socket || !data['agentId']) {
          this.showErrorDisconnect();
          return;
        }
        this.socket.send(payload);
      });
      return;
    }

    const data = this.standParam({});
    const payload = {
      data: data,
    };

    payload['objectId'] = environment.code.SUPVERVISOR_CALL_RESPONSE_ID;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  loadCallList() {
    if (!this.socket) {
      this.socketSource.subscribe(() => {
        const data = this.standParam({});
        const payload = {
          data: data,
        };

        payload['objectId'] = environment.code.CALL_LIST_RESPONSE_ID;
        if (!this.socket || !data['agentId']) {
          this.showErrorDisconnect();
          return;
        }
        if (!this.socket || !data['agentId']) {
          this.showErrorDisconnect();
          return;
        }

        this.socket.send(payload);
      });
      return;
    }

    const data = this.standParam({});
    const payload = {
      data: data,
    };

    payload['objectId'] = environment.code.CALL_LIST_RESPONSE_ID;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  standParam(data) {
    if (data['call_id']) {
      data['callId'] = data['call_id'];
      delete data.call_id;
    }
    // if (!this.username) {
    //   this.initData();
    // }
    this.initData();
    data['username'] = this.username;
    data['agentId'] = this.agentId;
    return data;
  }

  /**
   * Khi nhận được msg báo kết thúc cuộc gọi
   * @param username
   * @param data
   */
  endCall(username, data) {
    console.log('endcall');
    // if (data.username == username) {
    //   this.endCallAudio.play()
    //   this.is_finish = true;
    //   this.missionAnnouncedSource.next({
    //     action: "endCall",
    //     data: data,
    //   });
    // }
    this.endCallAudio.play();
    this.is_finish = true;
    this.missionAnnouncedSource.next({
      action: 'endCall',
      data: data,
    });
  }

  activateVoice() {
    const data = this.standParam({});
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.VOICE_ACTIVATED,
      data: data,
    });
  }

  answer(username, data) {
    if (data.username == username) {
      this.ticketService
        .updateStatusCalling({
          call_id: data['callId'],
          status: 'answer',
        })
        .subscribe(rs => {});
      this.missionAnnouncedSource.next({
        action: 'answer',
        data: data,
      });
      // this.monitor('call_answering',data['callId'], localStorage.getItem('caller'));
      // this.updateMonitor({
      //   event: 'call_answering',
      //   id:data['callId'],
      //   tenant_id: this.user.tenant_id
      // })
    }
  }

  hold(username, data) {
    if (data.username == username && data.status == 'OK') {
      this.missionAnnouncedSource.next({
        action: 'hold',
        data: {
          call_id: data.callId,
          username: data.username,
          agent_id: data.agentId,
        },
      });
      this.ticketService
        .updateMany({ call_id: data.callId }, { $inc: { holded_number: 1 }, is_holding: 1 })
        .subscribe(rs => {
          console.log('update holding for ticket');
        });
      // this.monitor('call_holding',data['callId']);
      // this.updateMonitor({
      //   event: 'call_holding',
      //   id:data['callId'],
      //   tenant_id: this.user.tenant_id
      // })
    }
  }

  unHold(username, data) {
    if (data.username == username && data.status == 'OK') {
      this.missionAnnouncedSource.next({
        action: 'unHold',
        data: {
          call_id: data.callId,
          username: data.username,
          agent_id: data.agentId,
        },
      });
      this.ticketService.updateMany({ call_id: data.callId }, { is_holding: 0 }).subscribe(rs => {
        console.log('update un-holding for ticket');
      });
      // this.monitor('call_unholding',data['callId']);
      // this.updateMonitor({
      //   event: 'call_unholding',
      //   id:data['callId'],
      //   tenant_id: this.user.tenant_id
      // })
    }
  }

  mute(username, data) {
    if (data.username == username && data.status == 'OK') {
      this.missionAnnouncedSource.next({
        action: 'mute',
        data: {
          call_id: data.callId,
          username: data.username,
          agent_id: data.agentId,
        },
      });
    }
  }

  unMute(username, data) {
    if (data.username == username && data.status == 'OK') {
      this.missionAnnouncedSource.next({
        action: 'unMute',
        data: {
          call_id: data.callId,
          username: data.username,
          agent_id: data.agentId,
        },
      });
    }
  }

  callOutResponseAction(username, data) {
    if (data.username == username && data.status == 'OK') {
      switch (data.action) {
        case 'CALL_OUT_HOLD': {
          this.hold(username, data);
          break;
        }
        case 'CALL_OUT_UNHOLD': {
          this.unHold(username, data);
          break;
        }
        case 'CALL_OUT_MUTE': {
          this.mute(username, data);
          break;
        }
        case 'CALL_OUT_UNMUTE': {
          this.unMute(username, data);
          break;
        }
        case 'TERMINATE': {
          this.endCall(username, data);
          break;
        }
        default:
          break;
      }
    }
  }

  showErrorDisconnect() {
    Sentry.captureMessage(
      `Tenant: ${this.user.tenant_id}|User: ${this.user._id}| Mất kết nối đến server!(wss disconnect now)`,
      Severity.Error
    );
    this.toastr.error('Mất kết nối đến server. Vui lòng thử lại sau', '', {
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
    });
  }

  execToOutPhone(data) {
    data = this.standParam(data);
    const payload = {
      data: data,
    };

    payload['objectId'] = environment.code.DIVERT_INVITE_REQUEST;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  execToACD(data) {
    data = this.standParam(data);
    const payload = {
      data: data,
    };

    payload['objectId'] = environment.code.TRANSFER_TO_ACD_REQUEST_ID;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  execToIVR(data) {
    data = this.standParam(data);
    const payload = {
      data: data,
    };

    payload['objectId'] = environment.code.TRANSFER_TO_IVR_REQUEST_ID;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  execUpdateAssignMe(data) {
    data = this.standParam(data);
    const payload = {
      data: data,
    };

    payload['objectId'] = 5000;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  execInvite(data) {
    data = this.standParam(data);
    const payload = {
      data: data,
    };

    payload['objectId'] = environment.code.INVITE_REQUEST_ID;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  execCallOutRequestAction(data) {
    data = this.standParam(data);
    const payload = {
      data: data,
    };

    payload['objectId'] = environment.code.PERFORMING_CALL_ACTION_REQUEST_ID;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  /**
   * Chuyển cuộc gọi cho agen khác
   * @param data
   */
  execForward(data) {
    data = this.standParam(data);
    const payload = {
      data: data,
    };

    payload['objectId'] = environment.code.TRANSFER_AGENT_TO_AGENT_REQUEST_ID;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  /**
   * xử lý tắt mở âm thanh
   * @param data
   * @param type
   */
  execMute(data, type) {
    data = this.standParam(data);

    const payload = {
      data: data,
    };
    if (type == 'on') {
      payload['objectId'] = environment.code.UNMUTE_REQUEST_ID;
    } else {
      payload['objectId'] = environment.code.MUTE_REQUEST_ID;
    }
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  /**
   * Xử lý hold hay unhold  cuộc gọi
   * @param data
   * @param type
   */
  execHold(data, type) {
    data = this.standParam(data);
    const payload = {
      data: data,
    };
    if (type == 'on') {
      payload['objectId'] = environment.code.UN_HOLD_REQUEST_ID;
    } else {
      payload['objectId'] = environment.code.HOLD_REQUEST_ID;
    }
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  /**
   * Xử lý chủ động kết thúc cuộc gọi
   * @param data
   */
  execEndCall(data) {
    // console.log('ecad')
    // this.endCallAudio.play();
    data = this.standParam(data);
    this.ticketService
      .updateStatusCalling({
        call_id: data['callId'],
        status: 'end_call',
      })
      .subscribe(rs => {
        console.log('end_call');
      });
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.AGENT_REJECT_CALL_REQUEST_ID,
      data: data,
    });
  }

  /**
   * Goi ra mot so dien thoai
   * @param phone
   */
  execCall(phone, ticketId: any = undefined, campaign_id: any = undefined) {
    const data = this.standParam({
      telephoneNumber: phone,
      ticketId: ticketId,
    });
    if (campaign_id) {
      data.campaignId = campaign_id;
    }
    const queue = localStorage.getItem('calloutDefault');
    if (queue) {
      data.queueId = queue;
    }
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.OUT_CALL_REQUEST_ID,
      data: data,
    });
    this.missionAnnouncedSource.next({
      action: 'hideVoiceBox',
      data: data,
    });
  }

  /**
   * Goi ra qua zalo
   * @param phone
   */
  execCallZcc(phone, ticketId: any = undefined, campaign_id: any = undefined) {
    const data = this.standParam({
      telephoneNumber: phone,
      ticketId: ticketId,
    });
    if (campaign_id) {
      data.campaignId = campaign_id;
    }
    data.callType = 'ZALO';
    const queue = localStorage.getItem('calloutDefault');
    if (queue) {
      data.queueId = queue;
    }
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.OUT_CALL_REQUEST_ID,
      data: data,
    });
    this.missionAnnouncedSource.next({
      action: 'hideVoiceBox',
      data: data,
    });
  }

  execRegisterUpdateAgent(agent_id, type = 0, new_agent_id?: any) {
    if (!this.socket) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.USER_PHONE_REGISTER,
      data: {
        actionType: type, // 0 : register , 1: update,
        newAgentId: new_agent_id ? new_agent_id : agent_id,
      },
    });
  }

  voiceSetting(data) {
    data = this.standParam(data);
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.USER_PHONE_SELECT,
      data: data,
    });
  }
  voiceOtherSetting(data) {
    this.socket.send({
      objectId: environment.code.USER_PHONE_SELECT,
      data: data,
    });
  }

  changeAgentStatus(data) {
    data = this.standParam(data);
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.CHANGE_AGENT_STATUS_REQUEST,
      data: data,
    });
  }

  changeAgentStatusSupervisor(data) {
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.CHANGE_AGENT_STATUS_REQUEST,
      data: data,
    });
  }

  getAgentAvailable(data) {
    data = this.standParam(data);
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.SEARCH_AGENT_REQUEST_ID,
      data: data,
    });
  }

  sendNotifyTicket(data) {
    data = this.standParam(data);
    const payload = {
      data: data,
    };

    payload['objectId'] = environment.code.SEND_CHAT_MESSAGE_EVENT;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  logout() {
    const data = this.standParam({});
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.LOGOUT_REQUEST_ID,
      data: data,
    });
  }

  logoutUser(agentId, username) {
    const data = {};
    data['username'] = username;
    data['agentId'] = agentId;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.LOGOUT_REQUEST_ID,
      data: data,
    });
  }

  interact(data) {
    data = this.standParam(data);
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.CALL_ACTION_REQUEST_ID,
      data: data,
    });
  }

  alertPhoneFailed(data) {
    data = this.standParam(data);
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.PHONE_ALERT_REQUEST_ID,
      data: data,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Socket.service.ts